import DomPurify from "isomorphic-dompurify";
import { useMemo } from "preact/hooks";
import defaultStyles from "./who-we-are.module.scss";
import mobileStyles from "./who-we-are-mobile.module.scss";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { LayoutStyleTypes, LayoutTypes, useLayoutType } from "@/util-react/layout";
import { FixBreadcrumb, useBreadcrumbs } from "@/elements-react/fix-breadcrumb";
import { Url } from "@/helpers/url.ts";

export function useWhoWeAreCommon(staticPageContent: string) {
  const { t } = useTranslation();
  const { layoutType } = useLayoutType();
  const isMobile = layoutType === LayoutTypes.TYPE_MOBILE;
  const additionalStyles = isMobile ? mobileStyles : defaultStyles;

  const content = useMemo(() => {
    return DomPurify.sanitize(staticPageContent);
  }, [staticPageContent]);

  const breadcrumbs = [
    {
      label: t("j70139vjmms2490f.whoWeAre", "Who we are"),
      url: Url.to("who-we-are-page"),
    },
  ];

  useBreadcrumbs(breadcrumbs);

  const renderContent = () => {
    const contentClassnames = classNames({
      [defaultStyles[LayoutStyleTypes.TYPE_SM]]: isMobile,
    });

    return (
      <div className={defaultStyles.wrapper}>
        <div className={contentClassnames}>
          <div class="static-page-content">
            <div className={defaultStyles.breadcrumbsNavigation}>
              <FixBreadcrumb />
            </div>

            <div dangerouslySetInnerHTML={{ __html: content }} />
          </div>
        </div>
      </div>
    );
  };

  return {
    renderContent,
  };
}
